module.exports = {"TXTCLI_Back":{"id":"TXTCLI_Back","defaultMessage":"Zurück","flags":["TRACK"],"track":"Back"}}